import { render, staticRenderFns } from "./UserAccountDataCard.vue?vue&type=template&id=2fdace94&scoped=true"
import script from "./UserAccountDataCard.vue?vue&type=script&lang=js"
export * from "./UserAccountDataCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdace94",
  null
  
)

export default component.exports